// src/js/config/deleteConfiguration.js

import { DOMElements } from './dom.js';
import { CONFIG_KEY_PREFIX } from './constants.js';
import { showMessage } from './ui/showMessage.js';
import { populateConfigSelect } from './ui/populateConfigSelect.js';
import { handleSelectConfigChangeUI } from './ui/handleSelectConfigChangeUI.js';
import { showPromptDeleteModal } from './ui/promptDeleteModal.js';

/**
 * Hanterar hela flödet för att radera en sparad konfiguration.
 */
export function deleteConfiguration() {
    const { selectConfig } = DOMElements;
    const strings = window.SimP_Strings || {};
    const selectedValue = selectConfig.value;

    // 1. Validera input
    if (selectedValue === "default" || !selectedValue) {
        showMessage(strings.delete_select_config_warning || 'Välj en konfiguration att ta bort.', 'warning');
        return;
    }

    const configKey = `${CONFIG_KEY_PREFIX}${selectedValue}`;
    const configName = selectConfig.options[selectConfig.selectedIndex].text;

    // 2. Visa bekräftelse-modal
    const message = (strings.delete_confirm_1 || 'Är du säker på att du vill ta bort "%s"?').replace('%s', `<span class="name">${configName}</span>`) +
                  '<br>' +
                  (strings.delete_confirm_2 || 'Denna åtgärd kan inte ångras.');

    showPromptDeleteModal(
        message,
        // Callback för "Bekräfta"
        () => {
            try {
                localStorage.removeItem(configKey);
                showMessage((strings.delete_success || 'Konfigurationen "%s" har tagits bort.').replace('%s', configName), 'success');

                // Återställ UI
                populateConfigSelect();
                // UI-hanteraren kommer automatiskt att köras av populateConfigSelect

            } catch (error) {
                console.error("Fel vid radering från Local Storage:", error);
                showMessage((strings.delete_errormessage || 'Kunde inte ta bort konfigurationen: ') + error.message, 'error');
            }
        },
        // Callback för "Avbryt"
        () => {
            showMessage(strings.delete_cancelled || 'Raderingen avbröts.', 'info');
        }
    );
}